import config from '../config';
let csrfToken = null;
export async function getCsrfToken() {
  if (csrfToken) return csrfToken;
  const response = await fetch(`${config.USER_ONBOARDING}/UAM/api/auth/csrf`, {
    credentials: 'include', cache: 'no-store'
  });
  if (!response.ok) throw new Error('Unable to obtain CSRF token');
  const data = await response.json();
  csrfToken = data.token;
  return csrfToken;
}
export function clearCsrfToken() { csrfToken = null; }
